export default '/build/e05bc924.svg'